import { render } from "./ToususEdit.vue?vue&type=template&id=2c9de5cf"
import script from "./ToususEdit.vue?vue&type=script&lang=js"
export * from "./ToususEdit.vue?vue&type=script&lang=js"

import "./ToususEdit.vue?vue&type=style&index=0&id=2c9de5cf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__